import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"
import _imports_0 from '@/components/img/sad.png'


const _hoisted_1 = {
  key: 0,
  class: "right0px"
}
const _hoisted_2 = {
  key: 0,
  class: "right0px"
}
const _hoisted_3 = {
  key: 0,
  class: "right0px"
}
const _hoisted_4 = {
  key: 1,
  class: "right0px"
}
const _hoisted_5 = {
  key: 0,
  class: "right0px"
}
const _hoisted_6 = {
  key: 0,
  class: "right0px"
}
const _hoisted_7 = {
  key: 0,
  class: "right0px"
}
const _hoisted_8 = {
  key: 0,
  class: "right0px"
}
const _hoisted_9 = { class: "right0px" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "margin-auto-rl",
  id: "sad_face",
  src: _imports_0,
  alt: "Sad face",
  style: {"height":"100px","margin-bottom":"16px"}
}, null, -1)
const _hoisted_11 = {
  style: {"text-align":"center"},
  class: "margin-auto-rl"
}

import { IonItem, IonImg, IonList } from '@ionic/vue';
import type { SingleDemoResult } from 'plate-vision-demo-openapi-client';
import TrustBar from '@/components/trust-bar.vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'vehicles-found',
  props: {
    totalVehicles: null,
    processedImageMimeType: null,
    displayDemoResult: null
  },
  setup(__props: any) {

const props = __props as {
    totalVehicles: number,
    processedImageMimeType: string,
    displayDemoResult: SingleDemoResult
};

const { t } = useI18n({
      inheritLocale: true,
      useScope: 'global'
})


const notAvailable = 'N/A';


// eslint-disable-next-line @typescript-eslint/no-unused-vars



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonItem), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonImg), {
          class: "margin-auto-rl margin-1-rem-tb",
          src: 'data:'+__props.processedImageMimeType+';base64,'+__props.displayDemoResult.vehicleImage
        }, null, 8, ["src"])
      ]),
      _: 1
    }),
    (__props.displayDemoResult.vehicle)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_unref(IonItem), null, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, _toDisplayString(_unref(t)('vehicleDetails.details')) + " (beta) ", 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), { class: "reportSubtitle" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('vehicleDetails.type')) + ": " + _toDisplayString(__props.displayDemoResult.vehicle?.category) + " ", 1),
              (__props.displayDemoResult.vehicle.categoryTrust)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString((__props.displayDemoResult.vehicle.categoryTrust*100).toFixed(1)) + " % ", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (__props.displayDemoResult.vehicle.categoryTrust)
            ? (_openBlock(), _createBlock(_unref(IonItem), {
                key: 0,
                class: "ion-align-items-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(TrustBar, {
                    "max-trust": 1,
                    "report-trust": __props.displayDemoResult.vehicle?.categoryTrust
                  }, null, 8, ["report-trust"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonItem), { class: "reportSubtitle" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('vehicleDetails.brand')) + ": " + _toDisplayString(__props.displayDemoResult.vehicle.make ? __props.displayDemoResult.vehicle.make : notAvailable) + " ", 1),
              (__props.displayDemoResult.vehicle.makeTrust)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString((__props.displayDemoResult.vehicle?.makeTrust*100).toFixed(1)) + " % ", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (__props.displayDemoResult.vehicle.makeTrust)
            ? (_openBlock(), _createBlock(_unref(IonItem), {
                key: 1,
                class: "ion-align-items-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(TrustBar, {
                    "max-trust": 1,
                    "report-trust": __props.displayDemoResult.vehicle.makeTrust
                  }, null, 8, ["report-trust"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonItem), { class: "reportSubtitle" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('vehicleDetails.model')) + ": " + _toDisplayString(__props.displayDemoResult.vehicle.model ? __props.displayDemoResult.vehicle.model : notAvailable) + " ", 1),
              (__props.displayDemoResult.vehicle.modelTrust)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString((__props.displayDemoResult.vehicle.modelTrust*100).toFixed(1)) + " % ", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (__props.displayDemoResult.vehicle.modelTrust)
            ? (_openBlock(), _createBlock(_unref(IonItem), {
                key: 2,
                class: "ion-align-items-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(TrustBar, {
                    "max-trust": 1,
                    "report-trust": __props.displayDemoResult.vehicle.modelTrust
                  }, null, 8, ["report-trust"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonItem), { class: "reportSubtitle" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('vehicleDetails.color')) + ": " + _toDisplayString(__props.displayDemoResult.vehicle.color ? __props.displayDemoResult.vehicle.color : notAvailable) + " ", 1),
              (__props.displayDemoResult.vehicle.color)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    style: _normalizeStyle('background-color: rgb('+ __props.displayDemoResult.vehicle.colorRgb?.r+','+__props.displayDemoResult.vehicle?.colorRgb?.g+','+__props.displayDemoResult.vehicle?.colorRgb?.b+'); width: 20%;height: 50%;border-radius: 2rem;position: relative;left: 16px;')
                  }, null, 4))
                : _createCommentVNode("", true),
              (__props.displayDemoResult.vehicle.colorTrust)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString((__props.displayDemoResult.vehicle.colorTrust*100).toFixed(1)) + " % ", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (__props.displayDemoResult.vehicle.colorTrust)
            ? (_openBlock(), _createBlock(_unref(IonItem), {
                key: 3,
                class: "ion-align-items-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(TrustBar, {
                    "max-trust": 1,
                    "report-trust": __props.displayDemoResult.vehicle.colorTrust
                  }, null, 8, ["report-trust"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonItem), { class: "reportSubtitle" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('vehicleDetails.orientation')) + ": " + _toDisplayString(__props.displayDemoResult.vehicle.orientation ? __props.displayDemoResult.vehicle.orientation : notAvailable) + " ", 1),
              (__props.displayDemoResult.vehicle.orientationTrust)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString((__props.displayDemoResult.vehicle.orientationTrust*100).toFixed(1)) + " % ", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (__props.displayDemoResult.vehicle.orientationTrust)
            ? (_openBlock(), _createBlock(_unref(IonItem), {
                key: 4,
                class: "ion-align-items-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(TrustBar, {
                    "max-trust": 1,
                    "report-trust": __props.displayDemoResult.vehicle.orientationTrust
                  }, null, 8, ["report-trust"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (__props.displayDemoResult.plateImage)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_unref(IonItem), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonImg), {
                class: "bradius12 margin-auto-rl margin-1-rem-tb",
                src: 'data:'+__props.processedImageMimeType+';base64,'+__props.displayDemoResult.plateImage
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), null, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, _toDisplayString(_unref(t)('vehicleDetails.plateDetails')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), { class: "reportSubtitle" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('vehicleDetails.text')) + ": " + _toDisplayString(__props.displayDemoResult.plate?.plateText ? __props.displayDemoResult.plate.plateText : notAvailable) + " ", 1),
              (__props.displayDemoResult.plate?.plateTextTrust)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString((__props.displayDemoResult.plate.plateTextTrust*100).toFixed(1)) + " % ", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (__props.displayDemoResult.plate?.plateTextTrust)
            ? (_openBlock(), _createBlock(_unref(IonItem), {
                key: 0,
                class: "ion-align-items-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(TrustBar, {
                    "max-trust": 1,
                    "report-trust": __props.displayDemoResult.plate.plateTextTrust
                  }, null, 8, ["report-trust"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonItem), { class: "reportSubtitle" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('vehicleDetails.textExt')) + ": " + _toDisplayString(__props.displayDemoResult.plate?.plateExtendedText ? __props.displayDemoResult.plate.plateExtendedText : notAvailable) + " ", 1),
              (__props.displayDemoResult.plate?.plateExtendedTextTrust)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString((__props.displayDemoResult.plate.plateExtendedTextTrust*100).toFixed(1)) + " % ", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (__props.displayDemoResult.plate?.plateExtendedTextTrust)
            ? (_openBlock(), _createBlock(_unref(IonItem), {
                key: 1,
                class: "ion-align-items-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(TrustBar, {
                    "max-trust": 1,
                    "report-trust": __props.displayDemoResult.plate.plateExtendedTextTrust
                  }, null, 8, ["report-trust"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonItem), { class: "reportSubtitle" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('vehicleDetails.country')) + ": " + _toDisplayString(__props.displayDemoResult.plate?.country ? __props.displayDemoResult.plate.country : notAvailable) + " ", 1),
              (__props.displayDemoResult.plate?.countryTrust)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString((__props.displayDemoResult.plate.countryTrust*100).toFixed(1)) + " % ", 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (__props.displayDemoResult.plate?.countryTrust)
            ? (_openBlock(), _createBlock(_unref(IonItem), {
                key: 2,
                class: "ion-align-items-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(TrustBar, {
                    "max-trust": 1,
                    "report-trust": __props.displayDemoResult.plate.countryTrust
                  }, null, 8, ["report-trust"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.displayDemoResult.plate?.region && __props.displayDemoResult.plate?.regionTrust)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createVNode(_unref(IonItem), { class: "reportSubtitle" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('vehicleDetails.region')) + ": " + _toDisplayString(__props.displayDemoResult.plate.region) + " ", 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString((__props.displayDemoResult.plate.regionTrust*100).toFixed(1)) + " % ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), { class: "ion-align-items-start" }, {
                  default: _withCtx(() => [
                    _createVNode(TrustBar, {
                      "max-trust": 1,
                      "report-trust": __props.displayDemoResult.plate.regionTrust
                    }, null, 8, ["report-trust"])
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createBlock(_unref(IonItem), {
                key: 4,
                class: "reportSubtitle"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('vehicleDetails.region')) + ": " + _toDisplayString(notAvailable), 1)
                ]),
                _: 1
              }))
        ], 64))
      : (_openBlock(), _createBlock(_unref(IonList), {
          key: 2,
          class: "bradius12",
          style: {"padding":"24px 0"}
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonItem), { style: {"width":"100%"} }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)('vehicleDetails.noDetection')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
  ], 64))
}
}

})